export default __webpack_public_path__ + "images/phone_icon.svg";